import { useMemo } from 'react';

import { useRouteLoaderData } from '@remix-run/react';

import type { loader as communityLayoutLoader } from '../../community';

export const useSpaceMembership = () => {
  const route = useRouteLoaderData<typeof communityLayoutLoader>('routes/community');

  const joinedSpaces = useMemo(() => new Set(route?.joinedSpaces ?? []), [route?.joinedSpaces]);

  return {
    joinedSpaces,
    isJoined: (spaceSlug: string) => joinedSpaces.has(spaceSlug),
  };
};
